import { render, staticRenderFns } from "./ProductsModal.vue?vue&type=template&id=02b0ce65&scoped=true"
import script from "./ProductsModal.vue?vue&type=script&lang=js"
export * from "./ProductsModal.vue?vue&type=script&lang=js"
import style0 from "./ProductsModal.vue?vue&type=style&index=0&id=02b0ce65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b0ce65",
  null
  
)

export default component.exports